import axios from 'axios'
import {
  CreateCreditCardBody,
  CreditCardWriteResponse,
  UpdateCreditCardBody,
  VerifyCreditCardBody,
} from 'src/queries/creditCards/network/creditCardWrites.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

/**
 * Pure network functions for the credit-card write endpoints. No React, no
 * React Query, no Redux dispatch. Errors are normalized at the boundary by
 * `getResponseData` (rejections become `QueryError`, so callers read the
 * backend payload via `error.error` without touching the raw AxiosError).
 */

export const postCreditCard = async (
  body: CreateCreditCardBody,
): Promise<CreditCardWriteResponse> =>
  getResponseData(
    axios.post<CreditCardWriteResponse>(
      `/creditcards`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const putCreditCard = async (
  creditCardId: string,
  body: UpdateCreditCardBody,
): Promise<CreditCardWriteResponse> =>
  getResponseData(
    axios.put<CreditCardWriteResponse>(
      `/creditcards/${creditCardId}`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const postVerifyCreditCard = async (
  creditCardId: string,
  body: VerifyCreditCardBody,
): Promise<CreditCardWriteResponse> =>
  getResponseData(
    axios.post<CreditCardWriteResponse>(
      `/creditcards/${creditCardId}/verify`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const postStartCreditCardVerification = async (
  creditCardId: string,
): Promise<CreditCardWriteResponse> =>
  getResponseData(
    axios.post<CreditCardWriteResponse>(
      `/creditcards/${creditCardId}/startverification`,
      undefined,
      getRequestConfig(RequestConfig.Default),
    ),
  )
